import './Alert.scss';
import { DialogModal } from '@components/Component/Container/Modal/DialogModal/DialogModal.js';
import { ReplaySubject } from 'rxjs';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { getID } from '@components/Utility/index.js';
/**
 *  `Alert` class extends `DialogModal`. This is intended to provide a simple way to display a stylized alert rather than using the built-in "alert" function.
 *
 */
export class Alert extends DialogModal {
    constructor() {
        super(...arguments);
        this.componentName = 'Alert';
    }
    open(options) {
        const { caption, captions } = options;
        if (caption?.indexOf('Silent:') === 0) {
            const subject = new ReplaySubject(1); // Buffer size of 1, to replay the last emitted value
            subject.next(false); // Emit 'false' immediately
            subject.complete(); // Complete the subject
            return subject;
        }
        // multi caption handling
        if (captions && captions.length) {
            captions.forEach((captionDef) => {
                const captionComponent = DIContainer.new('TextBase', getID('caption'), document.createElement('span'));
                if (typeof captionDef === 'string') {
                    captionComponent.caption = captionDef;
                }
                else if (captionDef.caption) {
                    captionComponent.caption = captionDef.caption;
                }
                else if (captionDef.captionKey) {
                    if (captionDef.captionKeyTokens) {
                        captionComponent.captionKeyTokens = captionDef.captionKeyTokens;
                    }
                    captionComponent.captionKey = captionDef.captionKey;
                }
                else {
                    return;
                }
                this.componentAdd(captionComponent, this.drawn);
            });
        }
        return super.open(options);
    }
    // there is no "cancelling" an alert. If you need a "yes or no" modal, use Confirm component
    cancel() {
        return this.submit(true);
    }
}
